export default "__VITE_ASSET__BAC4ytky__"